export function renderMultiRelationshipFieldActionButtonsTemplate({
  indent,
  fieldName,
  formItemProps,
  labelWithDescription,
  toPascalCase,
  toLowerCase,
  relSingular,
  dataArray,
  displayField,
  secondaryDisplayField,
  defaultValueFromHandlerContent
}: {
  indent: string
  fieldName: string
  formItemProps: string
  labelWithDescription: string
  toPascalCase: string
  toLowerCase: string
  relSingular: string
  dataArray: string
  displayField: string
  secondaryDisplayField: string
  defaultValueFromHandlerContent: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      ${labelWithDescription}
${indent}      <Popover open={${fieldName}Open} onOpenChange={set${toPascalCase}Open}>
${indent}        <PopoverTrigger
${indent}          render={
${indent}            <FormControl>
${indent}              <Button
${indent}              variant="outline"
${indent}              role="combobox"
${indent}              className={cn("w-full justify-between", {
${indent}                "text-muted-foreground": !formField.value || formField.value.length === 0
${indent}              })}
${indent}              disabled={isPending}
${indent}              >
${indent}              {(formField.value?.length ?? 0) > 0
${indent}                ? \`\${formField.value?.length ?? 0} selected\`
${indent}                : "Select ${toLowerCase}"}
${indent}                <ChevronsUpDown className="ml-2 size-4 shrink-0 opacity-50" />
${indent}              </Button>
${indent}            </FormControl>
${indent}          }
${indent}        />
${indent}        <PopoverContent className="w-full p-0" align="start">
${indent}          <Command>
${indent}            <CommandInput placeholder="Search ${toLowerCase}..." />
${indent}            <CommandList>
${indent}              <CommandEmpty>No ${relSingular} found.</CommandEmpty>
${indent}              <CommandGroup>
${indent}                {${dataArray}?.filter((item) => item.id !== null).map((item) => {
${indent}                  const displayName = ${displayField}
${indent}                  const secondaryDisplayName = ${secondaryDisplayField}
${indent}                  const isSelected = formField.value?.includes(item.id) || false
${indent}                  return (
${indent}                    <CommandItem
${indent}                      key={item.id}
${indent}                      value={displayName}
${indent}                      onSelect={() => {
${indent}                        const current = formField.value || []
${defaultValueFromHandlerContent}
${indent}                      }}
${indent}                    >
${indent}                      <Check className={cn("size-4", {
${indent}                        "opacity-100": isSelected,
${indent}                        "opacity-0": !isSelected
${indent}                      })} />
${indent}                      <span className="flex min-w-0 flex-col text-left">
${indent}                        <span className="truncate">{displayName}</span>
${indent}                        {secondaryDisplayName ? (
${indent}                          <span className="truncate text-xs text-muted-foreground">{secondaryDisplayName}</span>
${indent}                        ) : null}
${indent}                      </span>
${indent}                    </CommandItem>
${indent}                  )
${indent}                })}
${indent}              </CommandGroup>
${indent}            </CommandList>
${indent}          </Command>
${indent}        </PopoverContent>
${indent}      </Popover>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}
